import React, { useState } from 'react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';

// Fungsi untuk mendapatkan geolokasi pengguna
const getGeolocation = () => {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    } else {
      reject("Geolocation is not supported by this browser.");
    }
  });
};

const SelfCheckInGathering = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [message, setMessage] = useState('');
  const [geolocation, setGeolocation] = useState(null);

  // Validation schema menggunakan Yup
  const validationSchema = Yup.object({
    email: Yup.string().email('Email tidak valid').required('Email wajib diisi'),
    whatsapp: Yup.string()
      .matches(/^(?:\+62|0)[0-9]{9,}$/i, 'No Whatsapp tidak valid')
      .required('No Whatsapp wajib diisi'),
  });

  // Handle submit untuk Formik
  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      // Ambil geolokasi pengguna
      const position = await getGeolocation();
      const { latitude, longitude } = position.coords;
      setGeolocation({ latitude, longitude });

      // Format nomor Whatsapp jika perlu
      let formattedWhatsapp = values.whatsapp;
      if (formattedWhatsapp.startsWith('0')) {
        formattedWhatsapp = '+62' + formattedWhatsapp.slice(1);
      }

      // Kirim data menggunakan Axios ke API
      const response = await axios.post('https://rlagency.id/app/api_gathering_upi/self_check_in.php', {
        email: values.email,
        whatsapp: formattedWhatsapp,
        latitude,
        longitude,
      });

      // Cek response dari API
      const result = response.data;

      if (result.success) {
        setMessage('Self Check In anda berhasil, silahkan langsung memasuki ruangan');
        setIsValid(true);
        resetForm();  // Reset the form fields after submission
      } else {
        setMessage('Self Check In anda gagal. Periksa data kembali');
        setIsValid(false);
      }
    } catch (error) {
      setMessage('Terjadi kesalahan. Coba lagi.');
      setIsValid(false);
    }

    setModalOpen(true);
    setSubmitting(false);
  };

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100">
      <div className="container" style={{ maxWidth: '400px', width: '100%' }}>
      <img 
        src={`./logo-upi-dan-yayasan.png`} 
        alt="Logo Gathering" 
        style={{ 
            width: '150px', 
            marginBottom: '20px', 
            display: 'block', 
            margin: '0 auto' 
        }} 
      />
      <h5 className="text-center mb-4" style={{ marginTop:'20px'}}>Self Check In Gathering</h5>
        <div className="card p-4 shadow-sm rounded">
          <Formik
            initialValues={{ email: '', whatsapp: '' }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting, resetForm }) => (
              <Form>
                <div className="form-group">
                  <label htmlFor="email">Email:</label>
                  <Field
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    required
                  />
                  <ErrorMessage name="email" component="div" className="text-danger" />
                </div>

                <div className="form-group" style={{marginTop:'20px'}}>
                  <label htmlFor="whatsapp">No Whatsapp:</label>
                  <Field
                    type="text"
                    className="form-control"
                    id="whatsapp"
                    name="whatsapp"
                    required
                  />
                  <ErrorMessage name="whatsapp" component="div" className="text-danger" />
                </div>

                <button style={{marginTop:'20px'}} type="submit" className="btn btn-primary" disabled={isSubmitting}>
                  Check In
                </button>
              </Form>
            )}
          </Formik>
        </div>

        {/* Modal untuk hasil check-in */}
        <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} centered>
          <ModalHeader toggle={() => setModalOpen(!modalOpen)}>
            {isValid ? 'Self Check In Berhasil' : 'Self Check In Gagal'}
          </ModalHeader>
          <ModalBody style={{ textAlign: 'center' }}>
            <p>{message}</p>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={() => setModalOpen(false)}>
              Tutup
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
};

export default SelfCheckInGathering;
